import { skipToken, useQuery } from "@tanstack/react-query";
import { getTransactionFeesPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEE_DETAIL_QUERY_KEY = "TRANSACTIONS_FEE_DETAIL";

export const getTransactionsFeeDetailQueryKey = (publicID?: string | null) => [
  TRANSACTIONS_FEE_DETAIL_QUERY_KEY,
  publicID,
];

export const useTransactionsFeeDetail = (publicID?: string | null) =>
  useQuery({
    queryKey: getTransactionsFeeDetailQueryKey(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getTransactionFeesPublicID(publicID),
        )
      : skipToken,
    enabled: !!publicID,
  });
